<!--
  Bloques y marcas en el orden en que se escribieron.

  !! NO hay innerHTML. El texto sale por interpolación y los elementos los pone esta plantilla, así
  que no existe HTML de usuario que inyectar ni que sanear: un `<script>` escrito en una descripción
  se lee como texto porque nunca deja de serlo. Las imágenes van por [src] y las ligas por [href],
  los dos contextos que Angular sanea por su cuenta.
-->
<div class="wl-rt">
  <ng-container *ngFor="let b of blocks" [ngSwitch]="b.kind">
    <p class="wl-rt-p" *ngSwitchCase="'p'">
      <ng-container *ngTemplateOutlet="inline; context: { spans: b.spans }"></ng-container>
    </p>

    <h4 class="wl-rt-h" [class.is-1]="b.level === 1" [class.is-2]="b.level === 2" [class.is-3]="b.level === 3" *ngSwitchCase="'h'">
      <ng-container *ngTemplateOutlet="inline; context: { spans: b.spans }"></ng-container>
    </h4>

    <ul class="wl-rt-list" *ngSwitchCase="'ul'">
      <li *ngFor="let item of b.items"><ng-container *ngTemplateOutlet="inline; context: { spans: item }"></ng-container></li>
    </ul>

    <ol class="wl-rt-list" *ngSwitchCase="'ol'">
      <li *ngFor="let item of b.items"><ng-container *ngTemplateOutlet="inline; context: { spans: item }"></ng-container></li>
    </ol>

    <pre class="wl-rt-pre" *ngSwitchCase="'code'"><code>{{ b.spans?.[0]?.value }}</code></pre>

    <hr class="wl-rt-hr" *ngSwitchCase="'hr'" />

    <ng-container *ngSwitchCase="'image'">
      <ng-container *ngTemplateOutlet="imagen; context: { url: b.value, alt: b.alt }"></ng-container>
    </ng-container>
  </ng-container>
</div>

<!-- Las marcas de una línea. Se repite en párrafos, encabezados y puntos de lista. -->
<ng-template #inline let-spans="spans">
  <ng-container *ngFor="let s of spans" [ngSwitch]="s.kind">
    <span class="wl-rt-text" *ngSwitchCase="'text'">{{ s.value }}</span>
    <strong *ngSwitchCase="'strong'">{{ s.value }}</strong>
    <em *ngSwitchCase="'em'">{{ s.value }}</em>
    <code class="wl-rt-code" *ngSwitchCase="'code'">{{ s.value }}</code>
    <!-- `rel="noopener noreferrer"`: sin él, la página que se abre puede tocar la nuestra por
         `window.opener`, y estos destinos los escribe quien registra la tarea. -->
    <a class="wl-rt-link" *ngSwitchCase="'link'" [href]="s.href" target="_blank" rel="noopener noreferrer">{{ s.value }}</a>
    <ng-container *ngSwitchCase="'image'">
      <ng-container *ngTemplateOutlet="imagen; context: { url: s.value, alt: s.alt }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<!-- Una imagen y sus tres estados. La misma plantilla la use un bloque o una marca de línea. -->
<ng-template #imagen let-url="url" let-alt="alt">
  <ng-container [ngSwitch]="state(url)">
    <img class="wl-rt-img" *ngSwitchCase="'ready'" [src]="src(url)" [alt]="alt" (click)="openImage.emit(url)" />
    <span class="wl-rt-ph" *ngSwitchCase="'loading'"><i class="fa-solid fa-spinner fa-spin"></i> Cargando imagen…</span>
    <!-- Una URL que no es adjunto de esta tarea (pegada como texto desde otra) nunca va a
         resolver. Antes no se pintaba nada y el contenido se perdía sin que nadie se enterara. -->
    <span class="wl-rt-ph is-missing" *ngSwitchDefault [title]="url">
      <i class="fa-regular fa-image"></i> Imagen no disponible — {{ alt }}
    </span>
  </ng-container>
</ng-template>
